import { HitType, MultiselectHitType } from "src/types/Algolia";
import { CategoryTreeSlugOrder } from "src/organisms/AlgoliaProductList/AlgoliaProductList";

export const sortByAlphabet = (a: HitType, b: HitType): number =>
  a.label.split("||")[1].localeCompare(b.label.split("||")[1], undefined, {
    numeric: true,
    sensitivity: "base",
  });

const sizeWeight: { [p: string]: number } = [
  "one-size",
  "os",
  "3xs",
  "2xs",
  "xs",
  "s",
  "m",
  "l",
  "xl",
  "2x",
  "2xl",
  "3xl",
  "3x",
  "4xl",
  "5xl",
  "6xl",
  "7xl",
  "1-month",
  "3-months",
  "6-months",
  "12-months",
  "18-months",
  "2-years",
  "3-years",
  "5-years",
  "6-years",
  "7-years",
  "8-years",
  "10-years",
  "12-years",
  "16-years",
  "14-years",
  "18-years",
  "1",
  "2",
  "3",
  "4",
  "4-6",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "50-cm",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "60",
  "62",
  "65",
  "68",
  "70",
  "74",
  "75",
  "79",
  "80",
  "85",
  "86",
  "88",
  "90",
  "92",
  "94",
  "95",
  "98",
  "99",
  "100",
  "102",
  "104",
  "105",
  "106",
  "110",
  "112",
  "113",
  "114",
  "115",
  "116",
  "118",
  "119",
  "120",
  "121",
  "122",
  "123",
  "124",
  "128",
  "134",
  "136",
  "138",
  "139",
  "140",
  "140-146-2",
  "141",
  "142",
  "143",
  "146",
  "147",
  "148",
  "150",
  "151",
  "152",
  "154",
  "156",
  "158",
  "162",
  "163",
  "164",
  "170",
  "172",
  "176",
  "188",
  "c",
].reduce((a, b, i) => {
  a[b] = i + 1;
  return a;
}, {} as { [p: string]: number });

export const sortBySize = (a: HitType, b: HitType): number => {
  const aId = a.label.split("||")[0];
  const bId = b.label.split("||")[0];
  const aWeight = sizeWeight[aId];
  const bWeight = sizeWeight[bId];
  return aWeight && bWeight ? aWeight - bWeight : aId.localeCompare(bId);
};

export const sortBySlugOrder = (
  a: MultiselectHitType,
  b: MultiselectHitType,
  slugSortOrder: CategoryTreeSlugOrder
): number => slugSortOrder[a.slug] - slugSortOrder[b.slug];
